module.exports = __webpack_public_path__ + "img/glass.bc47b021.svg";